"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleInbox = exports.INBOX_TOGGLE = void 0;
var INBOX_TOGGLE = "inbox/TOGGLE_INBOX";
exports.INBOX_TOGGLE = INBOX_TOGGLE;

var toggleInbox = function toggleInbox(isOpen) {
  return {
    type: INBOX_TOGGLE,
    payload: isOpen
  };
};

exports.toggleInbox = toggleInbox;